import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking-outdoor',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-outdoor-f', 'age-walking-outdoor-f'],
		route: {
			path: '/walking-outdoor-f',
			name: 'walking-outdoor-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-outdoor',
		route: {
			path: '/walking-outdoor-f/ob/:page(.*)?',
			name: 'activity-female-walking-outdoor',
		},
		slug: 'activity-female-walking-outdoor',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-outdoor-f',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-walking-outdoor-f-us',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
}

export default appAreaConfig
